import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=7033bb8a&"
import script from "./EmployeeTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeTable.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=7033bb8a&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QTable,QInput,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInput,QTd})
